import apiClient from './apiClient';
import { EmailConfigSafe, EmailConfigInput, EmailTestResult } from '../types/emailConfig';

class EmailConfigService {
  private baseUrl = '/email-config';

  async get(): Promise<EmailConfigSafe | null> {
    const response = await apiClient.get(`${this.baseUrl}`);
    return response.data?.data ?? response.data ?? null;
  }

  async save(input: EmailConfigInput): Promise<EmailConfigSafe> {
    const response = await apiClient.put(`${this.baseUrl}`, input);
    return response.data?.data ?? response.data;
  }

  async test(input: EmailConfigInput): Promise<EmailTestResult> {
    const response = await apiClient.post(`${this.baseUrl}/test`, input);
    return response.data?.data ?? response.data;
  }
}

export const emailConfigService = new EmailConfigService();
export default emailConfigService;
